<!--
 * @Date: 2022-09-26 10:51:23
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-09 17:13:46
 * @description: description
-->

<template>
  <div :class="$style.aboutusMobile">
    <!-- 关于我们 -->
    <AboutusBanner id="profile" :info="info.banner" />
    <!-- 核心价值 -->
    <SenseOfWorth id="values" :info="info.senseOfWorth" />
    <!-- 发展历程 -->
    <DevelopmentHistory id="history" :info="info.developmentHistory" />
    <!-- 资质荣誉 -->
    <Honor id="honor" :info="info.honor" />
    <!-- 我的伙伴 -->
    <Partner id="partner" :info="info.partner" />
  </div>
</template>
<script>
import AboutusBanner from './Banner.vue'
import SenseOfWorth from './SenseOfWorth.vue'
import DevelopmentHistory from './DevelopmentHistory.vue'
import Honor from './Honor.vue'
import Partner from './Partner.vue'
export default {
  name: 'aboutusPC',
  components: {
    AboutusBanner,
    SenseOfWorth,
    DevelopmentHistory,
    Honor,
    Partner
  },
  props: {
    info: Object
  },
  watch: {
    $route: {
      handler (to, from) {
        this.$nextTick(() => {
          const queryId = '#' + this.$route.query.anchor
          const showTop = this.$el.querySelector(queryId).offsetTop
          const showHeight = showTop === 0 ? showTop - 52 : showTop
          // window.scrollTo({
          //   top: showTop === 0 ? showTop - 52 : showTop,
          //   behavior: 'smooth'
          // })
          // 滚动兼容
          document.body.scrollTop = showHeight
          document.documentElement.scrollTop = showHeight
        })
      },
      // 第一次就执行
      immediate: true
    }
  }
}
</script>

<style lang="scss" module>
.aboutusMobile {
  position: relative;
}
</style>
